import type { GetTagsItem, SubTopic, Topic, TopicTag, TopicTagSubTopic, TopicTagTopic } from '@api';

/** Subject tag with nested topics from `GET /v1/topic-tags` (no path on the DTO). */
export type NatCurriculumSubject = {
  id: string;
  label: string;
  topics: TopicItem[];
};

export type SubjectTagItem = {
  id: string;
  path: string;
  label: string;
};

export type SubTopicItem = {
  id: string;
  name: string;
};

export type TopicItem = {
  id: string;
  name: string;
  nat: string;
  subTopics: SubTopicItem[];
};

/**
 *
 * @returns The result of this operation.
 * @param dto The Dto value.
 */
export function mapNatCurriculumSubjectFromApi(dto: TopicTag): NatCurriculumSubject {
  return {
    id: dto.tagId,
    label: dto.tagLabel,
    topics: dto.topics.map((topic) => mapTopicTagTopicFromApi(topic)),
  };
}

/**
 *
 * @returns The result of this operation.
 * @param dtos The Dtos value.
 */
export function mapNatCurriculumSubjectsFromApi(dtos: TopicTag[]): NatCurriculumSubject[] {
  return dtos.map((dto) => mapNatCurriculumSubjectFromApi(dto));
}

/**
 *
 * @returns The result of this operation.
 * @param dto The Dto value.
 */
export function mapSubjectTagFromApi(dto: GetTagsItem): SubjectTagItem {
  return {
    id: dto.id,
    path: dto.path,
    label: dto.label,
  };
}

/**
 *
 * @returns The result of this operation.
 * @param dtos The Dtos value.
 */
export function mapSubjectTagsFromApi(dtos: GetTagsItem[]): SubjectTagItem[] {
  return dtos.map((dto) => mapSubjectTagFromApi(dto));
}

/**
 *
 * @returns The result of this operation.
 * @param dto The Dto value.
 */
export function mapSubTopicFromApi(dto: SubTopic | TopicTagSubTopic): SubTopicItem {
  return {
    id: dto.id,
    name: dto.name,
  };
}

/**
 *
 * @returns The result of this operation.
 * @param dtos The Dtos value.
 */
export function mapSubTopicsFromApi(dtos: (SubTopic | TopicTagSubTopic)[]): SubTopicItem[] {
  return dtos.map((dto) => mapSubTopicFromApi(dto));
}

/**
 *
 * @returns The result of this operation.
 * @param dto The Dto value.
 */
export function mapTopicFromApi(dto: Topic): TopicItem {
  return {
    id: dto.id,
    name: dto.name,
    nat: dto.nat,
    subTopics: mapSubTopicsFromApi(dto.subTopics),
  };
}

/**
 *
 * @returns The result of this operation.
 * @param dtos The Dtos value.
 */
export function mapTopicsFromApi(dtos: Topic[]): TopicItem[] {
  return dtos.map((dto) => mapTopicFromApi(dto));
}

/**
 *
 * @returns The result of this operation.
 * @param dto The Dto value.
 */
export function mapTopicTagTopicFromApi(dto: TopicTagTopic): TopicItem {
  return {
    id: dto.id,
    name: dto.name,
    // TopicTagTopic has no `nat` field — callers that need NAT codes use GET /v1/topics.
    nat: '',
    subTopics: mapSubTopicsFromApi(dto.subTopics),
  };
}
